import React, { useContext, useEffect, useState, useRef } from "react";
import { hasRole } from "../utils/guestUser";
import NavSub from "../components/NavSub";
import "../Styles/WeeklyTimesheet.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import { AuthContext } from "../context/AuthContext";
import {
  TextField,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  CircularProgress,
} from "@mui/material";
import * as XLSX from "xlsx";
import {
  CaretCircleDoubleLeft,
  CaretCircleDoubleRight,
  CaretDown,
  CaretUp,
  FileArrowUp,
} from "phosphor-react";
import { Button } from "bootstrap";
import ToastComponent from "../components/ToastComponent";
import { clientApiUrl, taskApiUrl } from "../utils/GetUrl";

const WeeklyTimesheet = () => {
  const [clients, setClients] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [viewForce, setViewForce] = useState([]);
  const { userData } = useContext(AuthContext);
  const [selectedTimeCode, setSelectedTimeCode] = useState(null);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [isAllowed, setIsAllowed] = useState(false);

  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date(); // Current date
    today.setDate(1); // Set to the first day of the current month
    return today.toISOString().split("T")[0]; // Convert to YYYY-MM-DD format
  });

  const [selectedDate2, setSelectedDate2] = useState(
    new Date().toISOString().split("T")[0], // Current date of the current month
  );
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [weeklyReport, setWeeklyReport] = useState([]);
  const { token, logout } = useContext(AuthContext);

  const [loadingActivities, setLoadingActivities] = useState(false);
  const [loadingViewForce, setLoadingViewForce] = useState(false);
  const [loadingWeeklyReport, setLoadingWeeklyReport] = useState(false);
  const [isDownloadable, setIsDownloadable] = useState(
    hasRole(userData?.[0]?.DR_Name, "Consultant") ? false : true,
  );
  const [currentWeek, setCurrentWeek] = useState(true);
  const filteredActivities =
    selectedActivities.length > 0
      ? selectedActivities
      : activityList.filter(
          (activity) =>
            activity &&
            typeof activity === "string" &&
            !activity.startsWith("9114"),
        );

  useEffect(() => {
    if (selectedDate && selectedDate2) {
      const startDate = new Date(selectedDate); // Start date from selectedDate
      const endDate = new Date(selectedDate2); // End date from selectedDate2

      // Format function to get date in YYYY-MM-DD format
      const formatDate = (date) => date.toISOString().split("T")[0];

      // Set formatted start and end dates
      setStartDate(formatDate(startDate));
      setEndDate(formatDate(endDate));
    }
  }, [selectedDate, selectedDate2]);

  useEffect(() => {
  }, [currentWeek, isDownloadable]);

  const toastRef = useRef();
  const fetchActivityList = async () => {
    if (!token) {
      return;
    }
    setLoadingActivities(true); // Start loading
    try {
      const response = await fetch(`${clientApiUrl}/GetAllActivity`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }
      if (response.ok) {
        const data = await response.json();
        const filteredData = data?.filter((i) => i.AL_Status == "1");
        // Filter out undefined/null values and ensure all are strings
        const activityCodes = filteredData
          ?.map((code) => code.AL_SalseforceCode)
          ?.filter(
            (code) =>
              code !== undefined && code !== null && typeof code === "string",
          );
        setActivityList([...new Set(activityCodes)]);
      }
    } catch (error) {
    } finally {
      setLoadingActivities(false); // End loading
    }
  };

  const checkIfDownloadable = async () => {
    if (!token) return false;

    try {
      const response = await fetch(`${taskApiUrl}/GetFileDownloadAction`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return false;
      }

      if (response.ok) {
        const data = await response.json();

        if (data && data.length > 0) {
          const validationDateStr = data[0].ValidationDate;
          const todayStr = new Date().toISOString().split("T")[0];

          if (todayStr <= validationDateStr) {
            return true;
          } else {
            toastRef.current.showToast(
              "Your download access has expired.",
              "warning",
            );
            return false;
          }
        } else {
          toastRef.current.showToast(
            "Download access not available.",
            "warning",
          );
          return false;
        }
      } else {
        toastRef.current.showToast("Failed to check download access.", "error");
        return false;
      }
    } catch (error) {
      console.error("Error checking download eligibility:", error);
      toastRef.current.showToast("Error checking download access.", "error");
      return false;
    }
  };

  const fetchViewForce = async () => {
    if (!token) {
      return;
    }
    try {
      const response = await fetch(
        `${taskApiUrl}/GetDataByDate?StartDate=${startDate}&EndDate=${endDate}&EMId=${userData?.[0]?.EM_ID}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }
      if (response.ok) {
        const data = await response.json();
        setViewForce(data);
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const fetchWeekly = async () => {
    if (!token) {
      return;
    }
    setLoadingWeeklyReport(true);
    try {
      const response = await fetch(
        `${taskApiUrl}/GetAllTaskClientWiseReport?DateRange1=${startDate}&DateRange2=${endDate}&AssginedToEmids='${userData?.[0]?.EM_ID}'`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }
      const data = await response.json();
      setWeeklyReport(data);
    } catch (e) {
    } finally {
      setLoadingWeeklyReport(false); // End loading
    }
  };

  useEffect(() => {
    if (userData && startDate) {
      fetchViewForce();
      fetchWeekly();
    }
  }, [userData, startDate, endDate, token]);

  useEffect(() => {
    fetchActivityList();
  }, [token]);

  const handleActivityChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedActivities(typeof value === "string" ? value.split(",") : value);
  };

  const downloadExcel = async () => {
    // First check if download is allowed
    // const isAllowed = await checkIfDownloadable();

    // if (!isAllowed) {
    //   return;
    // }

    // Generate table data using the same function as the UI
    const { header, data } = generateReportTable(
      filteredActivities, // Use the filteredActivities we calculated
      weeklyReport,
      viewForce,
    );

    // Create headers array that matches UI structure
    const excelHeaders = [
      "Client (ProjectNumber)",
      "Price Agreement",
      ...header.slice(2), // Skip the Client and Price Agreement which we handle separately
    ];

    // Prepare worksheet data
    const worksheetData = [
      excelHeaders,
      ...data.map((row) => [
        `${row.Client} (${row.ProjectNumber})`,
        row.SynergyPriceAgreement || "",
        ...excelHeaders.slice(2).map((col) => {
          // Handle nested properties
          if (col in row) {
            return row[col] !== undefined ? row[col] : 0;
          }
          return 0;
        }),
      ]),
    ];

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      `WeeklyReport_${userData?.[0]?.EM_FirstName}`,
    );

    // Generate and download the file
    XLSX.writeFile(
      workbook,
      `WeeklyReport_${userData?.[0]?.EM_FirstName}.xlsx`,
    );
  };

  function generateReportTable(activityList, weeklyReport, viewForce) {
    // If activityList is empty, return empty structure
    if (!activityList || activityList.length === 0) {
      return {
        header: [
          "Client",
          "Price Agreement",
          "SynergyFixedMinutes",
          "FixedMinutesVoucherProcessing",
          "STRActivityAverageTime",
        ],
        data: [],
        reportingActivities: [],
      };
    }

    // Filter out activities starting with "9114" and handle undefined values
    const filteredActivities = activityList.filter(
      (activity) =>
        activity &&
        typeof activity === "string" &&
        !activity.startsWith("9114"),
    );

    // If after filtering there are no activities, return empty structure
    if (filteredActivities.length === 0) {
      return {
        header: [
          "Client",
          "Price Agreement",
          "SynergyFixedMinutes",
          "FixedMinutesVoucherProcessing",
          "STRActivityAverageTime",
        ],
        data: [],
        reportingActivities: [],
      };
    }

    const uniqueActivities = [...new Set(filteredActivities)];

    // Get all reporting activities from standardActivitiesTime
    const reportingActivities = [];
    weeklyReport.forEach((report) => {
      if (report.standardActivitiesTime) {
        report.standardActivitiesTime.forEach((activity) => {
          if (activity.ActivityType === "Reporting Activites") {
            reportingActivities.push(activity.ActivityName);
          }
        });
      }
    });
    const uniqueReportingActivities = [...new Set(reportingActivities)];

    const tableHeader = [
      "Client",
      "Price Agreement",
      ...uniqueActivities,
      ...uniqueActivities.map((a) => `${a} ViewForce`),
      ...uniqueActivities.map((a) => `${a} Difference`),
      "SynergyFixedMinutes",
      "FixedMinutesVoucherProcessing",
      "STRActivityAverageTime",
      ...uniqueReportingActivities,
    ];

    const clientNames = [
      ...new Set(weeklyReport.map((report) => report.ClientName)),
    ];
    const clientIds = [
      ...new Set(weeklyReport.map((report) => report.ClientId)),
    ];
    const projectIds = [
      ...new Set(weeklyReport.map((report) => report.ProjectNumber)),
    ];

    const tableData = clientNames.map((clientName, index) => {
      const clientId = clientIds[index];
      const projectId = projectIds[index];
      const clientReport = weeklyReport.find(
        (report) => report.ClientName === clientName,
      );

      const clientRow = {
        clientName: clientName,
        ProjectNumber: projectId,
        clientId: clientId,
        SynergyPriceAgreement: clientReport?.SynergyPriceAgreement || "",
        SynergyFixedMinutes: clientReport?.SynergyFixedMinutes || "0",
        FixedMinutesVoucherProcessing:
          clientReport?.FixedMinutesVoucherProcessing || "0",
        STRActivityAverageTime: clientReport?.STRActivityAverageTime || "0",
        activitiesTotalTime: {},
        activitiesViewForceTime: {},
        activitiesDifference: {},
        reportingActivities: {},
      };

      // Initialize all activity times to 0
      uniqueActivities.forEach((activity) => {
        clientRow.activitiesTotalTime[activity] = 0;
        clientRow.activitiesViewForceTime[activity] = 0;
        clientRow.activitiesDifference[activity] = 0;
      });

      // Initialize all reporting activities to 0
      uniqueReportingActivities.forEach((activity) => {
        clientRow.reportingActivities[activity] = 0;
      });

      // Populate activity times from weeklyReport
      weeklyReport.forEach((report) => {
        if (
          report.ClientName === clientName &&
          uniqueActivities.includes(report.SalesforceCode)
        ) {
          clientRow.activitiesTotalTime[report.SalesforceCode] += parseFloat(
            parseFloat(report.TotalTime).toFixed(2),
          );
        }
      });

      // Populate viewForce times
      viewForce.forEach((view) => {
        if (
          view.clientId == clientId &&
          uniqueActivities.includes(view.activity)
        ) {
          clientRow.activitiesViewForceTime[view.activity] += parseFloat(
            (parseFloat(view.registeredTime) * 60).toFixed(2),
          );
        }
      });

      // Calculate differences
      uniqueActivities.forEach((activity) => {
        clientRow.activitiesDifference[activity] =
          clientRow.activitiesTotalTime[activity] -
          clientRow.activitiesViewForceTime[activity];
      });

      // Populate reporting activities from standardActivitiesTime
      if (clientReport?.standardActivitiesTime) {
        clientReport.standardActivitiesTime.forEach((activity) => {
          if (
            activity.ActivityType === "Reporting Activites" &&
            clientRow.reportingActivities[activity.ActivityName] !== undefined
          ) {
            clientRow.reportingActivities[activity.ActivityName] =
              activity.SATTime;
          }
        });
      }

      return clientRow;
    });

    return {
      header: tableHeader,
      data: tableData.map((clientRow) => {
        const row = {
          Client: clientRow.clientName,
          ProjectNumber: clientRow.ProjectNumber,
          SynergyPriceAgreement: clientRow.SynergyPriceAgreement,
          SynergyFixedMinutes: clientRow.SynergyFixedMinutes,
          FixedMinutesVoucherProcessing:
            clientRow.FixedMinutesVoucherProcessing,
          STRActivityAverageTime: clientRow.STRActivityAverageTime,
        };

        // Add activity times
        uniqueActivities.forEach((activity) => {
          row[activity] = clientRow.activitiesTotalTime[activity];
          row[`${activity} ViewForce`] =
            clientRow.activitiesViewForceTime[activity];
          row[`${activity} Difference`] =
            clientRow.activitiesDifference[activity];
        });

        // Add reporting activities
        uniqueReportingActivities.forEach((activity) => {
          row[activity] = clientRow.reportingActivities[activity];
        });

        return row;
      }),
      reportingActivities: uniqueReportingActivities,
    };
  }

  const { header, data, reportingActivities } = generateReportTable(
    filteredActivities, // Use the filteredActivities we calculated
    weeklyReport,
    viewForce,
  );
  const getRowStyle = (index) => ({
    backgroundColor: index % 2 === 0 ? "#f0f0f0" : "white",
  });

  const [isdateDropdownOpen, setdatebellDropdownOpen] = useState(false);
  const [chosenDate, setChosenDate] = useState("");

  const toggledateDropdown = () => {
    setdatebellDropdownOpen(!isdateDropdownOpen);
  };

  const handleProceed = () => {
    setChosenDate(selectedDate);
    setdatebellDropdownOpen(!isdateDropdownOpen);
  };

  const dropdown2Ref = useRef(null);

  const menuItemStyle = {
    height: "30px",
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const tableContainerRef = useRef(null);
  const handleMouseScroll = () => {
    const tableContainer = tableContainerRef.current;

    let isDown = false;
    let startX;
    let scrollLeft;

    const mouseDownHandler = (e) => {
      isDown = true;
      tableContainer.classList.add("active");
      startX = e.pageX - tableContainer.offsetLeft;
      scrollLeft = tableContainer.scrollLeft;
    };

    const mouseLeaveHandler = () => {
      isDown = false;
      tableContainer.classList.remove("active");
    };

    const mouseUpHandler = () => {
      isDown = false;
      tableContainer.classList.remove("active");
    };

    const mouseMoveHandler = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tableContainer.offsetLeft;
      const walk = (x - startX) * 2;
      tableContainer.scrollLeft = scrollLeft - walk;
    };
    tableContainer.addEventListener("mousedown", mouseDownHandler);
    tableContainer.addEventListener("mouseleave", mouseLeaveHandler);
    tableContainer.addEventListener("mouseup", mouseUpHandler);
    tableContainer.addEventListener("mousemove", mouseMoveHandler);
    return () => {
      tableContainer.removeEventListener("mousedown", mouseDownHandler);
      tableContainer.removeEventListener("mouseleave", mouseLeaveHandler);
      tableContainer.removeEventListener("mouseup", mouseUpHandler);
      tableContainer.removeEventListener("mousemove", mouseMoveHandler);
    };
  };

  // State for expanded sections
  const [isActualTimeExpanded, setIsActualTimeExpanded] = useState(true);
  const [isViewForceTimeExpanded, setIsViewForceTimeExpanded] = useState(false);
  const [isDifferenceExpanded, setIsDifferenceExpanded] = useState(false);
  const [isHoursExpanded, setIsHoursExpanded] = useState(false);

  // Calculate column positions

  const activityCount = filteredActivities.length;
  const actualTimeStart = 2; // After Client and Price Agreement
  const actualTimeEnd = actualTimeStart + activityCount;
  const viewForceStart = actualTimeEnd;
  const viewForceEnd = viewForceStart + activityCount;
  const differenceStart = viewForceEnd;
  const differenceEnd = differenceStart + activityCount;
  const hoursStart = differenceEnd;
  const hoursEnd = hoursStart + 3; // SynergyFixedMinutes, FixedMinutesVoucherProcessing, STRActivityAverageTime
  const reportingStart = hoursEnd;
  const reportingEnd = reportingStart + reportingActivities.length;

  return (
    <div>
      <NavSub />
      <div className="weekly_time_sheet_head">
        <div>
          <ToastComponent ref={toastRef} timeout={4000} />
          <div className="weekly-nav-edit">
            <Select
              className="change-font"
              multiple
              value={selectedActivities}
              onChange={handleActivityChange}
              displayEmpty
              onOpen={handleOpen}
              onClose={handleClose}
              IconComponent={() => null}
              renderValue={(selected) => {
                return (
                  <button className="title-weekly-design">
                    {selected.length > 0
                      ? `${selected.length} ACTIVITIES SELECTED`
                      : "SELECT ACTIVITY"}
                    {open ? (
                      <CaretUp
                        size={16}
                        weight="fill"
                        color="#3d025f"
                        className="icon-select-weekly"
                      />
                    ) : (
                      <CaretDown
                        size={16}
                        weight="fill"
                        color="#3d025f"
                        className="icon-select-weekly"
                      />
                    )}
                  </button>
                );
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              {activityList
                ?.filter(
                  (activity) =>
                    activity &&
                    typeof activity === "string" &&
                    !activity.startsWith("9114"),
                )
                .map((activity) => (
                  <MenuItem key={activity} value={activity} sx={menuItemStyle}>
                    <Checkbox
                      checked={selectedActivities.indexOf(activity) > -1}
                    />
                    <ListItemText primary={activity} />
                  </MenuItem>
                ))}
            </Select>

            <input
              type="date"
              className="date-design-weekly"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              label="Select Date"
            />
            <input
              type="date"
              className="date-design-weekly"
              value={selectedDate2}
              onChange={(e) => setSelectedDate2(e.target.value)}
              label="Select End Date"
            />
          </div>
        </div>
        <div className="Nav-btn-user">
          <FileArrowUp size={25} color="#3d025f" weight="fill" />
          <button className="Nav-Sub-btn" onClick={downloadExcel}>
            DOWNLOAD FILES
          </button>
        </div>
      </div>

      <div
        className="report-table-cont"
        ref={tableContainerRef}
        onMouseEnter={handleMouseScroll}
      >
        {loadingWeeklyReport ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <CircularProgress style={{ color: "purple" }} width={40} />
          </div>
        ) : (
          <table className="report-table">
            <thead>
              <tr className="super-header">
                {/* CLIENT Header */}
                <th
                  className="client-header"
                  style={{
                    position: "sticky",
                    left: 0,
                    zIndex: 1,
                    background: "rgba(230, 230, 230, 1)",
                  }}
                >
                  CLIENT
                </th>
                <th
                  className="client-header"
                  style={{
                    position: "sticky",
                    left: 304,
                    zIndex: 1,
                    background: "rgba(230, 230, 230, 1)",
                  }}
                >
                  Price Agreement
                </th>
                <th
                  className="hours-header"
                  colSpan={isHoursExpanded ? 3 : 1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsHoursExpanded((prev) => !prev)}
                >
                  {isHoursExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="orange" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="orange" />
                  )}
                  Fixed Time (Mins)
                </th>

                {/* REPORTING ACTIVITIES Header */}
                {reportingActivities.length > 0 && (
                  <th
                    className="reporting-header"
                    colSpan={isHoursExpanded ? reportingActivities.length : 1}
                    style={{ cursor: "pointer" }}
                  ></th>
                )}

                {/* ACTUAL TIME Header */}
                <th
                  className="total-time-header"
                  colSpan={isActualTimeExpanded ? activityCount : 1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsActualTimeExpanded((prev) => !prev)}
                >
                  {isActualTimeExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="green" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="green" />
                  )}
                  ACTUAL TIME
                </th>

                {/* VIEW FORCE TIME Header */}
                <th
                  className="viewforce-time-header"
                  colSpan={isViewForceTimeExpanded ? activityCount : 1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsViewForceTimeExpanded((prev) => !prev)}
                >
                  {isViewForceTimeExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="blue" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="blue" />
                  )}
                  VIEW FORCE TIME
                </th>

                {/* DIFFERENCE Header */}
                <th
                  className="difference-header"
                  colSpan={isDifferenceExpanded ? activityCount : 1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsDifferenceExpanded((prev) => !prev)}
                >
                  {isDifferenceExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="red" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="red" />
                  )}
                  DIFFERENCE
                </th>

                {/* HOURS Header */}
              </tr>

              {/* Activity Headers */}
              <tr className="activity-headers">
                <th className="activity-header table-title-weekly">CLIENT</th>
                <th className="activity-header table-title-weekly">
                  Price Agreement
                </th>
                {isHoursExpanded && (
                  <>
                    <th className="activity-header table-title-weekly">
                      SynergyFixedMinutes
                    </th>
                    <th className="activity-header table-title-weekly">
                      FixedMinutesVoucherProcessing
                    </th>
                    <th className="activity-header table-title-weekly">
                      STRActivityAverageTime
                    </th>
                  </>
                )}

                {/* Reporting Activities Headers */}
                {isHoursExpanded &&
                  reportingActivities.map((activity, index) => (
                    <th
                      className="activity-header table-title-weekly"
                      key={`reporting-${index}`}
                    >
                      {activity}
                    </th>
                  ))}
                {/* Actual Time Headers */}
                {isActualTimeExpanded &&
                  header
                    .slice(actualTimeStart, actualTimeEnd)
                    .map((head, index) => (
                      <th
                        className="activity-header table-title-weekly"
                        key={`actual-${index}`}
                      >
                        {head}
                      </th>
                    ))}

                {/* View Force Headers */}
                {isViewForceTimeExpanded &&
                  header
                    .slice(viewForceStart, viewForceEnd)
                    .map((head, index) => (
                      <th
                        className="activity-header table-title-weekly"
                        key={`viewforce-${index}`}
                      >
                        {head}
                      </th>
                    ))}

                {/* Difference Headers */}
                {isDifferenceExpanded &&
                  header
                    .slice(differenceStart, differenceEnd)
                    .map((head, index) => (
                      <th
                        className="activity-header table-title-weekly"
                        key={`difference-${index}`}
                      >
                        {head}
                      </th>
                    ))}

                {/* Hours Headers */}
              </tr>
            </thead>
            <tbody>
              {data?.map((row, index) => (
                <tr
                  className="client-row"
                  key={index}
                  style={getRowStyle(index)}
                >
                  {/* CLIENT Column */}
                  <td
                    className="client-name content-user"
                    style={{
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                      backgroundColor:
                        index % 2 === 0
                          ? "rgb(240, 240, 240)"
                          : "rgb(255, 255, 255)",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {row.Client} ({row.ProjectNumber})
                  </td>
                  <td
                    className="client-name content-user"
                    style={{
                      position: "sticky",
                      left: 304,
                      zIndex: 1,
                      backgroundColor:
                        index % 2 === 0
                          ? "rgb(240, 240, 240)"
                          : "rgb(255, 255, 255)",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {row.SynergyPriceAgreement}
                  </td>

                  {/* ACTUAL TIME Columns */}
                  {isActualTimeExpanded &&
                    header
                      .slice(actualTimeStart, actualTimeEnd)
                      .map((activity, activityIndex) => (
                        <td
                          className="activity-cell content-user"
                          key={`actual-${index}-${activityIndex}`}
                        >
                          <div className="activity-cell-value">
                            {row[activity]}
                          </div>
                        </td>
                      ))}

                  {/* VIEW FORCE TIME Columns */}
                  {isViewForceTimeExpanded &&
                    header
                      .slice(viewForceStart, viewForceEnd)
                      .map((activity, activityIndex) => (
                        <td
                          className="activity-cell content-user"
                          key={`viewforce-${index}-${activityIndex}`}
                        >
                          <div className="activity-cell-value">
                            {row[activity]}
                          </div>
                        </td>
                      ))}

                  {/* DIFFERENCE Columns */}
                  {isDifferenceExpanded &&
                    header
                      .slice(differenceStart, differenceEnd)
                      .map((activity, activityIndex) => (
                        <td
                          className="activity-cell content-user"
                          key={`difference-${index}-${activityIndex}`}
                        >
                          <div className="activity-cell-value">
                            {" "}
                            {row[activity] !== undefined
                              ? parseFloat(row[activity]).toFixed(2)
                              : ""}
                          </div>
                        </td>
                      ))}

                  {/* HOURS Columns */}
                  {isHoursExpanded && (
                    <>
                      <td className="activity-cell content-user">
                        <div className="activity-cell-value">
                          {row.SynergyFixedMinutes}
                        </div>
                      </td>
                      <td className="activity-cell content-user">
                        <div className="activity-cell-value">
                          {row.FixedMinutesVoucherProcessing}
                        </div>
                      </td>
                      <td className="activity-cell content-user">
                        <div className="activity-cell-value">
                          {row.STRActivityAverageTime}
                        </div>
                      </td>
                    </>
                  )}

                  {/* REPORTING ACTIVITIES Columns */}
                  {isHoursExpanded &&
                    reportingActivities.map((activity, activityIndex) => (
                      <td
                        className="activity-cell content-user"
                        key={`reporting-${index}-${activityIndex}`}
                      >
                        <div className="activity-cell-value">
                          {row[activity] || 0}
                        </div>
                      </td>
                    ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default WeeklyTimesheet;
